import React, { Dispatch, SetStateAction, useEffect } from "react";
import DommusToggle from "../DommusToggle";
import { Button, Col, Form, InputGroup, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import DommusRequiredSpan from "../DommusRequiredSpan";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt, faPlusCircle, faTimesCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useFieldArray, useForm } from "react-hook-form";
import { DommusInputErro } from "../DommusInputErro";
import './index.css'
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import { CabecalhosProps, WebhookType } from "../../pages/Integracoes/Webhooks/types";
import { WebhooksService } from "../../services/WebhooksService";
import { Option } from "react-multi-select-component/dist/lib/interfaces";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { DommusAlertaAmarelo } from "../DommusAlertaAmarelo";

interface DommusWebhookProps {
    webhook?: WebhookType
    setWebhooks: Dispatch<SetStateAction<WebhookType[]>>
}

interface FormularioWebhookProps {
    nome: string
    url: string
    cabecalhos: CabecalhosProps[] | null
    eventos: Array<null | undefined | number>
    ids_campanhas: number[] | null | Option[]
}

export function DommusWebhook({ webhook, setWebhooks }: DommusWebhookProps) {
    const configsMultiSelect = {
		selectSomeItems: 'Selecione',
		allItemsAreSelected: 'Todos itens selecionados',
		selectAll: 'Selecionar todos',
		search: 'Pesquisar',
	}
    const { control, handleSubmit, errors, reset } = useForm<FormularioWebhookProps>()
    const salvarWebhook = (dados: FormularioWebhookProps) => {
        if(!dados.cabecalhos) {
            dados.cabecalhos = null
        }
        if(dados.ids_campanhas?.length) {
            dados.ids_campanhas = dados.ids_campanhas.map(campanha => typeof campanha == 'object' && campanha.value)
        } else {
            dados.ids_campanhas = null
        }
        const promise = webhook ? WebhooksService.atualizar(webhook.id_webhook, dados) : WebhooksService.salvar(dados)
        trackPromise(promise)
            .then(response => {
                let msg
                if(!webhook) {
                    msg = 'Webhook cadastrado com sucesso.'
                    reset()
                    setWebhooks(webhooks => [...webhooks, response?.data])
                } else {
                    msg = 'Webhook atualizado com sucesso.'
                    setWebhooks(webhooks => {
                        const indexWebhookAtualizar = webhooks.findIndex(webhook => webhook.id_webhook == response.data.id_webhook)
                        webhooks[indexWebhookAtualizar] = response.data
                        
                        return webhooks
                    })
                }
                Swal.fire('Sucesso!', msg, 'success')
            }).catch(error => {
                console.log(error)
                console.log(error?.response)
                Swal.fire('Ooops...', 'Houve um erro ao tentar salvar o webhook.', 'error')
            })
    }
    const { 
        fields: camposCabecalhos, 
        prepend: adicionarCampoCabecalho, 
        remove: removerCampoCabecalho
    } = useFieldArray({
        name: "cabecalhos",
        control
    });
    const identificadorCheckboxEventoAlterarOportunidade = `evento-atualizar-opv${webhook ? webhook.id_webhook : 0}`
    const iconeExcluirWebhook = (
        <Row>
            <OverlayTrigger overlay={<Tooltip id={`tooltip-webhook-${webhook?.id_webhook}`}>Excluir Webhook</Tooltip>}>
                <Button variant="danger" className="mr-3" onClick={() => excluirWebhook(webhook?.id_webhook)}>
                    <FontAwesomeIcon icon={faTrashAlt as IconProp} color='#fff'/>
                </Button>
            </OverlayTrigger>
        </Row>
    )
    const ID_EVENTO_SISTEMA_NOVA_INDICACAO = 1

    useEffect(() => {
        if(!webhook) {
            adicionarCampoCabecalho({
                nome: 'Authorization',
                valor: ''
            })
        } else if(webhook?.cabecalhos?.length) {
            webhook.cabecalhos.forEach(cabecalho => {
                adicionarCampoCabecalho({
                    nome: cabecalho.nome,
                    valor: cabecalho.valor
                })
            })
        }
    }, [webhook])

    function adicionarCabecalho() {
        adicionarCampoCabecalho({
            nome: '',
            valor: ''
        })
    }

    function validarEventoWebhook(idEvento: number) {
        return !!webhook?.eventos?.find(evento => evento.id_evento == idEvento)
    }

    function excluirWebhook(id: number|undefined) {
        if(!id) {
            return
        }
        Swal.fire({
            title: 'Excluir Webhook?',
            text: 'Esta ação não pode ser revertida, deseja confirmar a exclusão?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Não, cancelar.',
            confirmButtonText: 'Sim, confirmar.',
            confirmButtonColor: 'var(--danger)'
        }).then(result => {
            if(result.isConfirmed) {
                trackPromise(WebhooksService.excluir(id))
                    .then(() => {
                        Swal.fire('Sucesso!', 'Webhook excluído com sucesso.', 'success')
                        setWebhooks(webhooks => webhooks.filter(webhook => webhook.id_webhook != id))
                    }).catch(error => {
                        console.log(error)
                        console.log(error?.response)
                        Swal.fire('Ooops...', 'Houve um erro ao tentar excluir o webhook.', 'error')
                    })
            }
        })
    }

    return <Form className="formCadastro px-3" onSubmit={handleSubmit(salvarWebhook)}>
        <DommusToggle title={webhook?.nome || 'Cadastrar Webhook'} icones={webhook && iconeExcluirWebhook || <></>}>
            <Row>
                <Form.Group as={Col}>
                    <Form.Label className="inputLabel">Nome: <DommusRequiredSpan/></Form.Label>
                    <Form.Control name="nome" ref={control.register({ required: true })} defaultValue={webhook?.nome || ''}/>
                    {errors?.nome && <DommusInputErro/>}
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="inputLabel">Url: <DommusRequiredSpan/></Form.Label>
                    <Form.Control name="url" ref={control.register({ required: true })} type="url" defaultValue={webhook?.url || ''}/>
                    {errors?.url && <DommusInputErro/>}
                </Form.Group>
            </Row>
            <Row className="px-3">
                <fieldset className="fieldset-scroll border col-12 px-3">
                    <legend className="inputLabel">Cabeçalhos</legend>
                    <Row className="justify-content-end mx-3">
                        <Button className="btn-sm" onClick={() => adicionarCabecalho()}>
                            <FontAwesomeIcon icon={faPlusCircle as IconProp}/> Adicionar Cabeçalho
                        </Button>
                    </Row>
                    {camposCabecalhos.length && camposCabecalhos.map((field, index) => {
                        return (
                            <Row key={field.id}>
                                <Form.Group as={Col}>
                                    <Form.Label className="inputLabel">Nome:</Form.Label>
                                    <Form.Control name={`cabecalhos.${index}.nome`} ref={control.register()} defaultValue={field.nome}/>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Label className="inputLabel">Valor:</Form.Label>
                                    <InputGroup>
                                        <Form.Control name={`cabecalhos.${index}.valor`} ref={control.register()} defaultValue={field.valor}/>
                                        <InputGroup.Append>
                                            <OverlayTrigger key={`cabecalho-${index}`} placement="top" overlay={<Tooltip id={`cabecalho-${index}`}>Excluir</Tooltip>}>
                                                <Button variant="danger" onClick={() => removerCampoCabecalho(index)}>
                                                    <FontAwesomeIcon icon={faTimesCircle as IconProp}/>
                                                </Button>
                                            </OverlayTrigger>
                                        </InputGroup.Append>
                                    </InputGroup>
                                </Form.Group>
                            </Row>
                        )
                    }) || <DommusAlertaAmarelo mensagem="Nenhum cabeçalho configurado." classe="text-center mt-3"/>}
                </fieldset>
            </Row>
            <Row className="px-3 mt-3">
                <fieldset className="fieldset-scroll col-12 p-3">
                    <legend className="inputLabel">Eventos</legend>
                    <Row className="px-3">
                        <Form.Check 
                            id={identificadorCheckboxEventoAlterarOportunidade} 
                            name="eventos.1" 
                            ref={control.register()} 
                            defaultChecked={validarEventoWebhook(ID_EVENTO_SISTEMA_NOVA_INDICACAO)}
                        /> 
                        <Form.Label htmlFor={identificadorCheckboxEventoAlterarOportunidade} className="pt-1 inputLabel">Alteração na Oportunidade</Form.Label>
                    </Row>
                </fieldset>
            </Row>
            <Row className="justify-content-end mx-1">
                <Button type="submit" variant="success" className="mt-3">
                    <FontAwesomeIcon icon={faCloudUploadAlt as IconProp}/> {webhook ? 'Atualizar' : 'Salvar'}
                </Button>
            </Row>
        </DommusToggle>
    </Form>
}